import { useEffect, useRef, useState } from "react";
export function useTimedLoading() {
  const [loading, setLoading] = useState(false);
  const [loadingTime, setLoadingTime] = useState(0);
  const loadingIntervalRef = useRef(null);

  useEffect(() => {
    if (loading) {
      setLoadingTime(0);
      loadingIntervalRef.current = setInterval(() => {
        setLoadingTime((loadingTime) => loadingTime + 1);
      }, 1000);
    } else {
      clearInterval(loadingIntervalRef.current);
    }

    return () => {
      clearInterval(loadingIntervalRef.current);
    };
  }, [loading]);

  return {
    loading,
    loadingTime,
    setLoading,
    setLoadingTime,
  };
}
